<!-- TYPEFACES RECORD View MAIN Column MAINBODY Record Table -->
<template>
    <div>
    <table class="table_typefaces">
        
            <thead>
                <tr>
                    <th>
                        <h4 :class="['datatable_cell_ch', sortNamech ? 'active' : '']" @click="sortbyNamech">字體</h4>
                        <h4 :class="['datatable_cell_eng', sortNameeng ? 'active' : '']" @click="sortbyNameeng">Typeface</h4>
                    </th>
                    <th>
                        <h4 :class="['datatable_cell_ch', sortCreatorch ? 'active' : '']" @click="sortbyCreatorch">創作者</h4>
                        <h4 :class="['datatable_cell_eng', sortCreatoreng ? 'active' : '']" @click="sortbyCreatoreng">Creator</h4>
                    </th>
                    <th>
                        <h4 :class="['datatable_cell_ch', sortFoundrych ? 'active' : '']" @click="sortbyFoundrych">團體</h4>
                        <h4 :class="['datatable_cell_eng', sortFoundryeng ? 'active' : '']" @click="sortbyFoundryeng">Type Foundry</h4>
                    </th>
                    <th>
                        <h4 :class="['datatable_cell_ch', sortGenrech ? 'active' : '']" @click="sortbyGenrech">風格</h4>
                        <h4 :class="['datatable_cell_eng', sortGenreeng ? 'active' : '']" @click="sortbyGenreeng">Genre</h4>
                    </th>
                    <th>
                        <h4 :class="['datatable_cell_cheng', sortMaterial ? 'active' : '']" @click="sortbyMaterial">載體材料 / Materials</h4>
                         <h4 :class="['datatable_cell_cheng', sortTechnique ? 'active' : '']" @click="sortbyTechnique">技術 / Technique</h4>
                    </th>
                    <th>
                         <h4 :class="['datatable_cell_cheng', sortCreationbegindate ? 'active' : '']" @click="sortbyCreationbegindate">起始日期 / Beginning</h4>
                         <h4 :class="['datatable_cell_cheng', sortCreationenddate ? 'active' : '']" @click="sortbyCreationenddate">完成日期 / End Date</h4>
                    </th>
                    <th :class="['sorttogether', sortRecordid ? 'active' : '']" @click="sortbyRecordid">
                        <h4 class="datatable_cell_ch">識別號</h4>
                        <h4 class="datatable_cell_eng">ID</h4>
                    </th>
                </tr>
            </thead>
            <tbody>
                <!-- : is for v-bind    @ is for v-on -->
                <!-- https://forum.vuejs.org/t/add-class-on-clicked-list-element-remove-class-from-not-clicked-elements/21771 -->
                <tr v-for="item in recordset" :key="item.id" @click="selectRecord(item.id, item.recordid, 'typeface')" :class="((item.recordid === initiallyselectedrecordid) && !recordwasclicked) || (item.id == recordkeyidselected) ? 'selected' : ''">
                    <td>
                        <p class="datatable_cell_ch">{{ item.namech }}</p>
                        <p class="datatable_cell_eng">{{ item.nameeng }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_ch">{{ item.creatorch }}</p>
                        <p class="datatable_cell_eng">{{ item.creatoreng }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_ch">{{ item.foundrych }}</p>
                        <p class="datatable_cell_eng">{{ item.foundryeng }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_ch">{{ item.genrech }}</p>
                        <p class="datatable_cell_eng">{{ item.genreeng }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_eng">{{ item.material }}</p>
                        <p class="datatable_cell_eng">{{ item.technique }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_eng">{{ item.creationbegindate }}</p>
                        <p class="datatable_cell_eng">{{ item.creationenddate }}</p>
                    </td>
                    <td>
                        <p class="datatable_cell_id">{{ item.recordid }}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
</template>

<script>
import store from '@/store'
import router from '@/router'

export default {
    name: 'RecordtableTypefaces',
    props: {
        recordsettoshow: Array,
        initiallyselectedrecordid: String
    },
    data(){
        return {
            recordkeyidselected: undefined,
            recordwasclicked: false,
            recordset: this.recordsettoshow,
            sortNamech: false,
            sortNameeng: false,
            sortCreatorch: false,
            sortCreatoreng: false,
            sortFoundrych: false,
            sortFoundryeng: false,
            sortGenrech: false,
            sortGenreeng: false,
            sortMaterial: false,
            sortTechnique: false,
            sortCreationbegindate: false,
            sortCreationenddate: false,
            sortRecordid: false,
        }
    },
    methods: {
        selectRecord(keyid, selectedrecordid, selectedrecordtype) { 
            this.recordwasclicked = true

            this.recordkeyidselected = keyid 
            //Set currentRecordType
            store.state.currentRecordType = selectedrecordtype
            //Set currentRecordID            
            store.state.currentTypefaceRecordID = selectedrecordid
            store.commit('updateMenuOpened', true)
            //Push to new URL
            router.push(`/records/` + selectedrecordtype + `/${store.state.currentTypefaceRecordID}`, () => {}) 
            //Last part catches the error https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378 when same link pressed twice
            //Doesn't happen when using router-link, but need to use this for the router.push
        },
        sortbyNamech(){
            this.sortNamech = true
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscnamech
        },
        sortbyNameeng(){
            this.sortNamech = false
            this.sortNameeng = true
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscnameeng
        },
        sortbyCreatorch(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = true
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAsccreatorch
        },
        sortbyCreatoreng(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = true
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAsccreatoreng
        },
        sortbyFoundrych(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = true
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscfoundrych
        },
        sortbyFoundryeng(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = true
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscfoundryeng
        },
        sortbyGenrech(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = true
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscgenrech
        },
        sortbyGenreeng(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = true
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscgenreeng
        },
        sortbyMaterial(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = true
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAscmaterial
        },
        sortbyTechnique(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = true
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAsctechnique
        },
        sortbyCreationbegindate(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = true
            this.sortCreationenddate = false
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAsccreationbegindate
        },
        sortbyCreationenddate(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = true
            this.sortRecordid = false
            this.recordset = store.getters.sortTypefacesAsccreationenddate
        },
        sortbyRecordid(){
            this.sortNamech = false
            this.sortNameeng = false
            this.sortCreatorch = false
            this.sortCreatoreng = false
            this.sortFoundrych = false
            this.sortFoundryeng = false
            this.sortGenrech = false
            this.sortGenreeng = false
            this.sortMaterial = false
            this.sortTechnique = false
            this.sortCreationbegindate = false
            this.sortCreationenddate = false
            this.sortRecordid = true
            this.recordset = store.getters.sortTypefacesAscrecordid
        },
    },
}
</script>